import React, { Component } from 'react';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import TestimonialAPIConnectors from '../../api/TestimonialAPIConnectors';
import AdminTestimonialTable from '../../components/testimonial/AdminTestimonialTable';

class AdminTestimonialContainer extends Component {
  componentDidMount() {
    const { actions } = this.props;

    // Fetch testimonials
    actions.fetchTestimonialRequest();
    TestimonialAPIConnectors.getTestimonials()
      .then((data) => {
        actions.fetchTestimonialSuccess(data);
      })
      .catch(() => {
        actions.fetchTestimonialFailure();
      });
  }

  updateTestimonial = (id, newValue) => TestimonialAPIConnectors.updateTestimonial(id, newValue);

  deleteTestimonial = id => TestimonialAPIConnectors.deleteTestimonial(id);

  render() {
    const {
      testimonial,
      actions,
      metadata,
    } = this.props;
    const {
      testimonials: allTestimonials,
    } = testimonial;
    const callbacks = {
      updateTestimonialCallback: this.updateTestimonial,
      deleteTestimonialCallback: this.deleteTestimonial,
    };

    if (testimonial.isLoading || metadata.isLoading) {
      return <div>{i18n.t('loading')}</div>;
    }

    return (
      <AdminTestimonialTable
        testimonials={allTestimonials}
        actions={actions}
        callbacks={callbacks}
        medicalGroups={metadata.data.medicalGroup}
        specialties={metadata.data.specialty}
      />
    );
  }
}

export default connectActionsAndReducers(AdminTestimonialContainer);



// WEBPACK FOOTER //
// ./src/containers/testimonial/AdminTestimonialContainer.js